import React from 'react';

import {observer} from "mobx-react";
import {LineupsWidgetAsync} from "../../../lineups-widget/components/lineups-widget.async";

export const GameCenterWidgetContentLineupsTab = observer(({controller, matchupId, gameId, location, showOdds}) => {
  const {state} = controller;
  const {shouldRenderLineups} = state;

  const lineupsProps = {
    matchupId,
    gameId,
    location,
    showOdds,
  }

  return (shouldRenderLineups ? <>
    <LineupsWidgetAsync {...lineupsProps}/>
  </> : null)
});
